import { Axios } from "@/utils/axios";

/** 통합 리드 진입점. 견적 제외 (체크리스트·홈). 체크리스트는 사용처가 많아 홈부터 순차 이관. */
export type LeadType = "checklist" | "home";

/**
 * 임박도 닫힌 enum. UI 문구 ≠ 저장값.
 * BE가 status → 슬랙 *메모* 문구 / Lead.status / 상담전사 멘션으로 매핑한다.
 * (매핑 표는 BE 소관. `1달` 저장값 분리 여부는 스레드 논의 중.)
 */
export type LeadUrgencyStatus = "여유" | "1달" | "임박" | "임종상태";

export interface PostLeadV2Body {
  /** 010-XXXX-XXXX. slack_message에 넣지 말 것 (BE가 부착). */
  phone: string;
  lead_type: LeadType;
  /**
   * 사람용 본문만. 넣지 말 것 (BE가 부착):
   * 채널 헤더 / 전화번호 / *메모* / 야간수신동의 / 장컴임박도우회 / GA·Hackle·GCLID / ops 서브팀 멘션 /
   * 🚨 임종 여부 반드시 확인 🚨 / (체크리스트) 고객여정 placeholder.
   */
  slack_message: string;
  /** 없/null/"" → 메모 미부착, Lead.status 빈값. */
  status?: LeadUrgencyStatus;
  /** 야간 여부는 useGetServerTime().is_night 로 판별해 야간일 때 동의값 전달. */
  accept_night_call?: boolean;
  /**
   * true면 홈질문 야간 장컴 인계에서 임박도 게이트만 건너뛴다.
   * 장컴 시간(근무시간 포함)은 BE가 판정. 프론트 is_night로 켜지 않음.
   * 식장 재방문 비용문의는 항상 true. 체크리스트에는 적용되지 않음.
   * slack_message에 넣지 말 것 (BE가 부착).
   */
  is_force_outsourcing_night_call?: boolean;
}

/** 성공 201, Lead id 동기 응답 없음 (웹훅 비동기 생성). */
export const postLeadV2 = async (body: PostLeadV2Body) => {
  const { data } = await Axios.post("/v2/leads/", body);
  return data;
};
